import React, { useState, useRef } from 'react';

const FORMATS = [
  { value: 'pdf', label: 'PDF' },
  { value: 'docx', label: 'DOCX' },
  { value: 'html', label: 'HTML' },
  { value: 'txt', label: 'Text' },
  { value: 'md', label: 'Markdown' },
];

const OCR_LANGS = [
  { value: 'deu+eng', label: 'DE + EN' },
  { value: 'deu', label: 'Deutsch' },
  { value: 'eng', label: 'English' },
];

export default function Convert() {
  const [file, setFile] = useState(null);
  const [targetFormat, setTargetFormat] = useState('pdf');
  const [converting, setConverting] = useState(false);
  const [error, setError] = useState(null);
  const [dragOver, setDragOver] = useState(false);
  const [ocrMode, setOcrMode] = useState(false);
  const [ocrLang, setOcrLang] = useState('deu+eng');
  const inputRef = useRef(null);

  const handleConvert = async () => {
    if (!file) return;
    setConverting(true); setError(null);
    const fd = new FormData();
    fd.append('file', file);
    try {
      let r;
      if (ocrMode) {
        fd.append('language', ocrLang);
        r = await fetch('/api/ocr', { method: 'POST', body: fd });
      } else {
        fd.append('target_format', targetFormat);
        r = await fetch('/api/convert', { method: 'POST', body: fd });
      }
      if (!r.ok) throw new Error(await r.text());
      const blob = await r.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = file.name.replace(/\.[^.]+$/, '') + (ocrMode ? '_ocr.pdf' : '.' + targetFormat);
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) { setError(e.message); }
    setConverting(false);
  };

  return (
    <div style={{ padding: 'var(--gap-lg)', maxWidth: 600 }}>
      <h2 style={{ color: 'var(--text-primary)', marginBottom: 'var(--gap-lg)', fontSize: 'var(--font-size-xl)', fontWeight: 600 }}>Konverter</h2>
      <div style={{ display: 'flex', gap: 8, marginBottom: 'var(--gap-md)' }}>
        {[false, true].map(m => (
          <button key={String(m)} onClick={() => setOcrMode(m)} style={{ background: ocrMode === m ? 'rgba(187,154,247,0.2)' : 'var(--bg-tertiary)', border: `1px solid ${ocrMode === m ? '#bb9af7' : 'var(--border)'}`, borderRadius: 'var(--border-radius)', padding: '6px 14px', color: ocrMode === m ? '#bb9af7' : 'var(--text-secondary)', cursor: 'pointer', fontSize: 'var(--font-size-sm)' }}>
            {m ? 'OCR' : 'Format'}
          </button>
        ))}
      </div>
      <div
        onDragOver={e => { e.preventDefault(); setDragOver(true); }}
        onDragLeave={() => setDragOver(false)}
        onDrop={e => { e.preventDefault(); setDragOver(false); setFile(e.dataTransfer.files[0]); }}
        onClick={() => inputRef.current?.click()}
        style={{ border: `2px dashed ${dragOver ? '#bb9af7' : 'var(--border)'}`, borderRadius: 'var(--border-radius-lg)', padding: 32, textAlign: 'center', cursor: 'pointer', background: file ? 'rgba(187,154,247,0.05)' : 'var(--bg-secondary)', marginBottom: 'var(--gap-md)' }}
      >
        {file ? <span style={{ color: 'var(--text-primary)' }}>{file.name}</span> : <span style={{ color: 'var(--text-muted)' }}>Datei waehlen oder hierher ziehen</span>}
        <input ref={inputRef} type="file" hidden onChange={e => setFile(e.target.files[0])} />
      </div>
      {!ocrMode ? (
        <div style={{ display: 'flex', gap: 8, marginBottom: 'var(--gap-md)', flexWrap: 'wrap' }}>
          {FORMATS.map(f => (
            <button key={f.value} onClick={() => setTargetFormat(f.value)} style={{ background: targetFormat === f.value ? 'rgba(187,154,247,0.2)' : 'var(--bg-tertiary)', border: `1px solid ${targetFormat === f.value ? '#bb9af7' : 'var(--border)'}`, borderRadius: 'var(--border-radius)', padding: '8px 16px', color: targetFormat === f.value ? '#bb9af7' : 'var(--text-secondary)', cursor: 'pointer', fontSize: 'var(--font-size-sm)' }}>
              {f.label}
            </button>
          ))}
        </div>
      ) : (
        <div style={{ display: 'flex', gap: 8, marginBottom: 'var(--gap-md)' }}>
          {OCR_LANGS.map(l => (
            <button key={l.value} onClick={() => setOcrLang(l.value)} style={{ background: ocrLang === l.value ? 'rgba(187,154,247,0.2)' : 'var(--bg-tertiary)', border: `1px solid ${ocrLang === l.value ? '#bb9af7' : 'var(--border)'}`, borderRadius: 'var(--border-radius)', padding: '8px 16px', color: ocrLang === l.value ? '#bb9af7' : 'var(--text-secondary)', cursor: 'pointer', fontSize: 'var(--font-size-sm)' }}>
              {l.label}
            </button>
          ))}
        </div>
      )}
      <button onClick={handleConvert} disabled={!file || converting} style={{ background: '#bb9af7', border: 'none', borderRadius: 'var(--border-radius)', padding: '10px 24px', color: '#1a1b26', fontWeight: 600, cursor: 'pointer', opacity: (!file || converting) ? 0.5 : 1 }}>
        {converting ? 'Konvertiere...' : ocrMode ? 'OCR starten' : 'Konvertieren'}
      </button>
      {error && <div style={{ color: '#f7768e', marginTop: 12, fontSize: 'var(--font-size-sm)' }}>{error}</div>}
    </div>
  );
}
